import {defineTokens} from '@chakra-ui/react3'

const chakraAspectRatios = defineTokens.aspectRatios({
    square: {value: '1 / 1'},
    landscape: {value: '4 / 3'},
    portrait: {value: '3 / 4'},
    wide: {value: '16 / 9'},
    ultrawide: {value: '18 / 5'},
    golden: {value: '1.618 / 1'}
})

const leapAspectRatios = defineTokens.aspectRatios({
    '1-1': {value: '1 / 1'},
    '4-3': {value: '4 / 3'},
    '3-4': {value: '3 / 4'},
    '3-2': {value: '3 / 2'},
    '2-3': {value: '2 / 3'},
    '16-9': {value: '16 / 9'},
    '9-16': {value: '9 / 16'},
    '16-10': {value: '16 / 10'},
    '10-16': {value: '10 / 16'}
})

export const aspectRatios = defineTokens.aspectRatios({
    ...chakraAspectRatios,
    ...leapAspectRatios
})
